import { For } from "solid-js";
import { TranslationField } from "~/components/TranslationField";
import { Card, CardContent, CardHeader } from "~/components/ui/card";
import { Separator } from "~/components/ui/separator";
import { Text } from "~/components/ui/text";
import { cn } from "~/util/utils";
import type { ListAppearance } from "../../../types/list";
import type { ListSection as ListSectionType } from "../../../types/section";
import { ListLinkItem } from "../LinkItem";

interface ListSectionProps {
	section: ListSectionType;
	appearance: ListAppearance;
}

export function ListSection(props: ListSectionProps) {
	return (
		<Card class="bg-zinc-50 overflow-hidden">
			<CardHeader class="p-4 bg-accent text-foreground">
				<TranslationField key={props.section.title}>
					{(title) => (
						<Text
							class="font-bold text-transparent bg-inherit bg-clip-text"
							size="lg"
							style={{
								filter: "invert(10) grayscale(1) contrast(1100)",
							}}
						>
							{title()}
						</Text>
					)}
				</TranslationField>
			</CardHeader>
			<Separator />
			<CardContent class="bg-white px-0 overflow-x-auto pb-0">
				<For each={props.section.items}>
					{(item, index) => (
						<ListLinkItem
							class={cn(props.section.items.length - 1 === index() && "border-b-0")}
							link={item}
							appreance={props.appearance}
						/>
					)}
				</For>
			</CardContent>
		</Card>
	);
}
